module.exports = __webpack_public_path__ + "static/media/strange0.8bfac977.png";